module.exports = __webpack_public_path__ + "static/img/wode_toppic.08e4dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wode_toppic.png
// module id = AGHG
// module chunks = 1